module.exports = "../../static/img/logo-login.e74b557.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-login.png
// module id = 658
// module chunks = 1